import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { useAuth0 } from '@auth0/auth0-react';
import UserUtils from 'utils/user-utils';
import { COLONIAL_OPERATOR_ID } from 'common/constants';
import Auth0Loading from './Auth0Loading';
import { redirectIgnoredPaths } from './utils';
const Login = ({ history }) => {
    const { loginWithRedirect } = useAuth0();
    const userStatus = useSelector(({ user }) => user.data.status);
    const urlParams = new URLSearchParams(history?.location?.search);
    const rawNextParam = urlParams.get('next');
    const operatorId = new URLSearchParams(rawNextParam?.split('?')[1]).get('operator_id');
    const isColonialFlow = Number(operatorId) === COLONIAL_OPERATOR_ID;
    // We want to avoid infinite loops so ignore next params that could just lead back to this component
    const shouldIgnoreNextParam = rawNextParam &&
        redirectIgnoredPaths.some(path => rawNextParam.startsWith(path));
    // next param needs to stay encoded so it can be decoded properly in Auth0Callback
    const nextParam = rawNextParam && !shouldIgnoreNextParam
        ? encodeURIComponent(rawNextParam)
        : null;
    useEffect(() => {
        // if the user is already logged in, redirect to the home page
        if (userStatus === UserUtils.AUTH_STATE.USER && !isColonialFlow) {
            history.push('/');
            return;
        }
        // otherwise redirect to the auth0 ULP
        const appState = nextParam ? { returnTo: nextParam } : null;
        loginWithRedirect({ appState }).catch(() => history.push('/auth/error'));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [history, loginWithRedirect, nextParam, userStatus]);
    return <Auth0Loading />;
};
Login.propTypes = {
    history: PropTypes.object.isRequired,
};
export default Login;
